import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownWithoutOptionsProps } from "../models";

const FinancialRiskLevelDropdown = (props: DropdownWithoutOptionsProps<server.dto.FinancialRiskLevel>) => {
  return <BaseReactSelectDropdown
    excludeKeys={[]}
    value={props.value}
    onChange={props.onChange}
    options={serverReference.financialRiskLevels}
    getLabel={financialRisk => financialRisk.text}
    getValue={financialRisk => financialRisk.value}
    config={{
      isSearchable: false,
      ...props.config
    }}
    renderOption={(status) => <div className="flex align-center">
      <div className="ui circular empty label" style={{ backgroundColor: status.hexColor, marginRight: 10 }}></div>
      <span>{status.text}</span>
    </div>}
    renderSelectedValue={(status) => <div className="flex align-center">
      <div className="ui circular empty label" style={{ backgroundColor: status.hexColor, marginRight: 10 }}></div>
      <span>{status.text}</span>
    </div>}
  />;
};

export default FinancialRiskLevelDropdown;